var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3318_11753)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    transform: "translate(-35 -152)",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -32.5,
    width: 359,
    height: 96,
    rx: 4.5,
    fill: "#FDE2DD",
    stroke: "#F1D1C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FC5758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7296 21.3599C23.1419 21.7843 23.0753 22.4146 22.5803 22.7681C22.3622 22.9238 22.0973 23 21.834 23C21.4997 23 21.168 22.8774 20.9376 22.64L15.9996 17.5349L11.0634 22.6131C10.8327 22.8504 10.5012 22.9731 10.1669 22.9731C9.90369 22.9731 9.63898 22.8969 9.4206 22.7411C8.92552 22.3877 8.8588 21.7574 9.27135 21.333L14.481 15.9736L9.27047 10.6412C8.85803 10.2168 8.92468 9.58653 9.41987 9.23309C9.91423 8.87872 10.6496 8.93572 11.0626 9.36103L15.9996 14.4381L20.9359 9.35997C21.3479 8.93559 22.0836 8.87809 22.5786 9.23203C23.0737 9.58547 23.1404 10.2158 22.7279 10.6402L17.5182 15.9995L22.7296 21.3599Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3318_11753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white",
    transform: "translate(-35 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.26096e775bbe5e60bdc4e75f70ec79c7.svg";
export { ForwardRef as ReactComponent };